import { ForgotPassword } from 'module/authentication/components/forgot-password';
import { PageLoading } from 'module/ui/components/atoms/loading';
import { useAuthenticateLinks } from 'helpers/use-authenticate-links';
import { useAccountMetaQuery } from 'queries/account';

export const ForgotPasswordPage = () => {
  const { data, isLoading, isError } = useAccountMetaQuery();
  const links = useAuthenticateLinks();

  return isLoading ? (
    <PageLoading></PageLoading>
  ) : data != null && !isError ? (
    <ForgotPassword
      links={links}
      company={data.company}
      isLoading={isLoading}
    ></ForgotPassword>
  ) : (
    <></>
  );
};
